import { Label, Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { Data } from '../../data/Data';
import { DataDemande } from '../../data/DataDemande';
import { DataDocument, TYPES_DOCUMENT } from '../../data/DataDocument';
import { DataRelance } from '../../data/DataRelance';
import { IDS_TYPE_TRANSMISSION } from '../../data/DataTypeTransmission';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxDocument } from '../ComboBox/ComboBoxDocument';
import { ComboBoxTypeTransmission } from '../ComboBox/ComboBoxTypeTransmission';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import { PickerEmail } from '../Picker/PickerEmail';
import { FicheEnvoiEmail } from './FicheEnvoiEmail';
import { DataOperation } from '../../data/DataOperation';

export class FicheRelance extends Component {

    static defaultProps = {
        idDemande: undefined,
        idRelance: undefined,
        /* --- */
        onDismiss: () => null,
        onEnregistrement: () => null
    };

    static defaultState = {
        demande: {},
        relance: {
            idTypeTransmission: 0,
            relance: "",
            dateRelance: Scriba.date().getChaineISOFromDate(new Date(Date.now())),
        },
        documentSelectionne: 0,
        emailsSelectionnes: [],
        from: "",
        sujet: "",
        typeDestinataireSelectionne: 0,
        /* --- */
        onActiveBoutonEnregistrer: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheRelance.defaultState };
    };

    _afficherPanelEnvoiEmail = () => {
        //MG: 27/09/2022 - 2139
        console.log('demande is:', this.state.demande);
        const { idOperation, idReservation } = this.state.demande;
        const { sujet } = this.state;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Initialisation du formulaire en cours..."
        });

        let promises = [Data._getAdresseEmailFromBackOffice()];
        if (!!idOperation)
            promises.push(DataOperation._chargementOperationEtLotCommercial(idOperation, idReservation));

        Promise.all(promises).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const email = responseFetch.reponseAPIobjet || "";
                const state = { from: email, afficherPanelEnvoiEmail: true };

                if (!!idOperation) {
                    const infoOperationEtLotCommercial = responseFetch[1].reponseAPIobjet[0] || "";
                    if (infoOperationEtLotCommercial !== "") {
                        const ville = infoOperationEtLotCommercial['ville'];
                        const nomCommercial = infoOperationEtLotCommercial['nomCommercial'];
                        const numero = infoOperationEtLotCommercial['numero'] !== null ? ' - ' + infoOperationEtLotCommercial['numero'] : '';
                        const acquereurs = infoOperationEtLotCommercial['acquereurs'] !== null ? ' - ' + infoOperationEtLotCommercial['acquereurs'] : '';
                        state.sujet = `${ville} - ${nomCommercial} / ${sujet} ${numero} ${acquereurs}`;
                    }
                    else {
                        state.sujet = `${sujet}`;
                    }
                }

                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

        this.setState({});
    };

    _chargementDonnees = () => {
        if (this._estFicheOuverteEnModeCreation()) this._chargementDonneesEnModeCreation();
        else this._chargementDonneesEnModeConsultation();
    }

    _chargementDonneesEnModeCreation = () => {

        const { idDemande } = this.props;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement en cours..."
        });

        const chargementDemande = DataDemande._chargementDemande(idDemande);
        const chargementRelances = DataRelance._chargementRelances({ idDemande }, "CreerLe", true, 1, 1);

        Promise.all([chargementDemande, chargementRelances]).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                // Demande
                const reponseAPIobjet = responseFetch[0].reponseAPIobjet || {};
                const demande = reponseAPIobjet.demande || {};
                const demandeStandard = reponseAPIobjet.demandeStandard || {};
                const emails = reponseAPIobjet.emails || [];
                const typeDestinataireSelectionne = reponseAPIobjet.typeDestinataire || 0;

                // Relances
                const relances = responseFetch[1].reponseAPIobjet || [];
                const derniereRelanceEffectuee = relances.length > 0 ? relances[0] : {};

                // Récupérer texte et emails de la dernière relance, ou de la demande si aucune relance n'a encore été effectuée
                const messageLePlusRecent = derniereRelanceEffectuee.relance || demande.demande || "";
                const emailsDeLaRelance = !!derniereRelanceEffectuee.emails ? derniereRelanceEffectuee.emails.split(";") : [];
                const emailsDeLaDemande = demande.idTypeTransmission === IDS_TYPE_TRANSMISSION.EMAIL
                    ? !!demande.emails ? demande.emails.split(";") : []
                    : emails;
                const derniersEmailsUtilises = emailsDeLaRelance.length > 0 ? emailsDeLaRelance : emailsDeLaDemande;

                const relance = { ...this.state.relance, relance: messageLePlusRecent, idTypeTransmission: demande.idTypeTransmission || 0 };
                const state = {
                    relance,
                    demande,
                    emailsSelectionnes: derniersEmailsUtilises,
                    sujet: demandeStandard.titre || "",
                    typeDestinataireSelectionne,
                };

                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onVerificationFormulaire);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _chargementDonneesEnModeConsultation = () => {

        const { idRelance } = this.props;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement de la relance en cours..."
        });

        DataRelance._chargementRelance(idRelance).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const estPublipostageDejaEffectue = this._estPublipostageDejaEffectue();
                const callback = estPublipostageDejaEffectue
                    ? this._onVerificationFormulaire
                    : () => {
                        const { idDemande } = this.props;
                        DataDemande._chargementDemande(idDemande).then(responseFetch => {
                            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                            if (retourVerif === null) {
                                const reponseAPIobjet = responseFetch.reponseAPIobjet || {};
                                const demande = reponseAPIobjet.demande || {};
                                const typeDestinataireSelectionne = reponseAPIobjet.typeDestinataire || 0;
                                this.setState({ demande, typeDestinataireSelectionne }, this._onVerificationFormulaire);
                            }
                        });
                    };

                const relance = responseFetch.reponseAPIobjet || {};
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, { relance }, callback);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    _enregistrer = (callback) => () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Enregistrement de la relance en cours..."
        });

        const { idDemande } = this.props;
        const relance = { idDemande, ...this.state.relance };

        DataRelance._onEnregistrementRelance(relance)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const jRelance = responseFetch.reponseAPIobjet || {};
                    const state = { relance: { ...relance, idRelance: jRelance.idRelance } };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, callback);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });

    };

    _estFicheOuverteEnModeCreation = () => {
        return !this.props.idRelance;
    };

    _estFicheOuverteEnModeConsultation = () => {
        return !!this.props.idRelance;
    };

    _estPublipostageDejaEffectue = () => {
        const { rowGUID } = this.state.relance;
        return !!rowGUID && rowGUID !== "00000000-0000-0000-0000-000000000000";
    };

    _onOpen = () => {
        this.setState({ ...FicheRelance.defaultState }, this._chargementDonnees);
    };

    _onRenderFooterContent = () => {
        const { relance, onActiveBoutonEnregistrer, documentSelectionne, emailsSelectionnes } = this.state;
        const estFicheOuverteEnModeCreation = this._estFicheOuverteEnModeCreation();
        const estPublipostageDejaEffectue = this._estPublipostageDejaEffectue();

        return <Stack horizontal gap={8}>
            {estFicheOuverteEnModeCreation && <PrimaryButton onClick={this._enregistrer(this.props.onEnregistrement)} disabled={!onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>}
            {relance.idTypeTransmission === IDS_TYPE_TRANSMISSION.COURRIER && !estPublipostageDejaEffectue &&
                <PrimaryButton
                    disabled={!onActiveBoutonEnregistrer || !documentSelectionne}
                    onClick={this._enregistrer(this._publiposter)}
                    text="Enregistrer et générer courrier"
                />
            }
            {estFicheOuverteEnModeCreation && relance.idTypeTransmission === IDS_TYPE_TRANSMISSION.EMAIL &&
                <PrimaryButton
                    disabled={!onActiveBoutonEnregistrer || emailsSelectionnes.length == 0}
                    onClick={this._enregistrer(this._afficherPanelEnvoiEmail)}
                    text="Enregistrer et générer email"
                />
            }
            <DefaultButton onClick={this.props.onDismiss}>Fermer</DefaultButton>
        </Stack>;
    };

    _onSend = (destinataires) => {
        const callback = () => this.setState({ afficherPanelEnvoiEmail: false }, this.props.onEnregistrement);
        this._updateRelance(
            { emails: destinataires.join(";") },
            this._enregistrer(callback)
        );
    };

    _onVerificationFormulaire = () => {
        const { idDemande } = this.props;
        const relance = { idDemande, ...this.state.relance };
        Immocom.fiche()._validationFormulaire(this, "Relance", relance, this._estFicheOuverteEnModeCreation() ? "Création" : "Consultation");
    };

    _publiposter = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Génération du courrier en cours..."
        });

        const { relance, documentSelectionne } = this.state;

        DataRelance._onPublipostageRelance(relance.idRelance, documentSelectionne)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const document = responseFetch.reponseAPIobjet || {};
                    const fichier = Scriba.fichier().Base64VersByteArray(document.fileData || []);
                    Scriba.fichier().EnregisterSous(fichier, document.nom);
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this.props.onEnregistrement);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });

    };

    _telechargerDocument = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Téléchargement du courrier..."
        });

        DataDocument._onTelechargementDocument(this.state.relance.rowGUID).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const document = Scriba.fichier().Base64VersByteArray(objetData.fileData);
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {}, true);
                return Scriba.fichier().EnregisterSous(document, objetData.nom);
            }
            else {
                Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            }
        });
    };


    _updateRelance = (values, callback) => {
        const relance = { ...this.state.relance, ...values };
        this.setState(
            { relance },
            () => {
                this._onVerificationFormulaire();
                if (!!callback) callback();
            }
        );
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { afficherPanelEnvoiEmail, typeDestinataireSelectionne, documentSelectionne, emailsSelectionnes, sujet, from } = this.state;
        const { idTypeTransmission, emails, relance, dateRelance, creerLe, creerPar, modifierLe, modifierPar } = this.state.relance;
        const { idOperation } = this.state.demande;
        const estFicheOuverteEnModeCreation = this._estFicheOuverteEnModeCreation();
        const estFicheOuverteEnModeConsultation = this._estFicheOuverteEnModeConsultation();
        const estPublipostageDejaEffectue = this._estPublipostageDejaEffectue();
        const aujourdhui = new Date(Date.now());

        const getSousCategorieDocument = () => {
            switch (typeDestinataireSelectionne) {
                case "client": return "Vers client";
                case "commercialisateur": return "Vers commercialisateur";
                case "intervenantExtPersonne": return "Vers intervenant ext. (personne)";
                case "intervenantExtSociete": return "Vers intervenant ext. (société)";
                case "operationnel": return "Vers opérationnel";
                default: return undefined;
            };
        };

        return <Fragment>
            <Panel
                closeButtonAriaLabel="Fermer"
                headerText={estFicheOuverteEnModeCreation ? "Nouvelle relance" : `Relance du ${Scriba.date().stringDateFormatCourt(dateRelance)}`}
                isOpen={isOpen}
                onDismiss={onDismiss}
                onOpen={this._onOpen}
                onRenderFooterContent={this._onRenderFooterContent}
                type={PanelType.medium}
            >

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                <Stack>

                    <MessageBars
                        errorMessage={this.state.errorMessage}
                        infoMessage={this.state.messageMessageBarFiltres}
                        warningMessage={this.state.warningMessage}
                        onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                        onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                    />

                    <div className="ms-Grid" dir="ltr">
                        <div className="ms-Grid-row">

                            <div className="ms-Grid-col ms-sm12 ms-lg6">
                                <ComboBoxTypeTransmission
                                    disabled={estFicheOuverteEnModeConsultation}
                                    onChange={(event, option, index, value) => { this._updateRelance({ idTypeTransmission: option.key }); }}
                                    required
                                    selectedKey={idTypeTransmission}
                                />
                            </div>

                            {idTypeTransmission === IDS_TYPE_TRANSMISSION.COURRIER && !estPublipostageDejaEffectue &&
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <ComboBoxDocument
                                        categorie="Demande"
                                        disabled={!typeDestinataireSelectionne}
                                        idOperation={idOperation}
                                        label="Modèle de courrier"
                                        onChange={(event, option, index, value) => { this.setState({ documentSelectionne: option.key }); }}
                                        placeholder="Modèle de courrier"
                                        selectedKey={documentSelectionne}
                                        sousCategorie={getSousCategorieDocument()}
                                        type={TYPES_DOCUMENT.OPERATION}
                                    />
                                </div>
                            }

                            {idTypeTransmission === IDS_TYPE_TRANSMISSION.COURRIER && estPublipostageDejaEffectue &&
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <Label>Modèle de courrier</Label>
                                    <DefaultButton
                                        iconProps={{ iconName: "Download" }}
                                        text="Télécharger courrier publiposté"
                                        onClick={this._telechargerDocument}
                                        styles={{ root: { width: "100%", textAlign: "left" } }}
                                    />
                                </div>
                            }

                            {idTypeTransmission === IDS_TYPE_TRANSMISSION.EMAIL &&
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <PickerEmail
                                        disabled
                                        emails={estFicheOuverteEnModeCreation ? emailsSelectionnes : (emails || "").split(";")}
                                    />
                                </div>
                            }

                        </div>
                        <div className="ms-Grid-row">

                            <div className="ms-Grid-col ms-sm12 ms-lg6">
                                <EUIDatePicker
                                    disabled={estFicheOuverteEnModeConsultation}
                                    label="Relance effectuée le"
                                    onSelectDate={(date) => this._updateRelance({ dateRelance: Scriba.date().getChaineISOFromDate(date, true) }, this._onVerificationFormulaire)}
                                    isRequired
                                    maxDate={aujourdhui}
                                    value={dateRelance}
                                />
                            </div>

                        </div>
                        <div className="ms-Grid-row">

                            <div className="ms-Grid-col ms-sm12">
                                <EUITextField
                                    label="Relance"
                                    maxLength={MaxLengths.relance.relance}
                                    multiline
                                    onDelayedChange={(event, newValue) => this._updateRelance({ relance: newValue }, this._onVerificationFormulaire)}
                                    readOnly={estFicheOuverteEnModeConsultation}
                                    rows={15}
                                    value={relance}
                                />
                            </div>

                        </div>
                    </div>

                    {!estFicheOuverteEnModeCreation &&
                        <div className="divDateCreationModification">
                            {!!creerLe && !!creerPar && <div>Créée le {Scriba.date().stringDateFormatCourt(creerLe)} par {creerPar}</div>}
                            {!!modifierLe && !!modifierPar && <div>Modifiée le {Scriba.date().stringDateFormatCourt(modifierLe)} par {modifierPar}</div>}
                        </div>
                    }

                </Stack>

                <FicheEnvoiEmail
                    emails={emailsSelectionnes}
                    from={from}
                    corps={relance}
                    sujet={sujet}
                    isOpen={afficherPanelEnvoiEmail}
                    onDismiss={() => this.setState({ afficherPanelEnvoiEmail: false })}
                    onSend={this._onSend}
                />

            </Panel>

        </Fragment>;

    };

};